import { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import { Form, Button, Input, Select, Upload, message, Modal, Row, Col } from 'antd'
import { PlusOutlined, EditOutlined } from '@ant-design/icons'
import { axiosHandleEvent, axiosTable } from '../../tool/axios'
import { formItemLayout, tailLayout, ngetBase64 } from '../../js/globalParam'
import { apiPrefix } from '../../js/config'
import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'
import E from 'wangeditor'

const { Option } = Select

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'

    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
        message.error('上传图片不能大于3MB!')
    }

    return isJpgOrPng && isLt3M
}

export default function HealthListAdd() {

    const [previewImage, setPreviewImage] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)

    const [formInstance] = Form.useForm()
    const [response, setResponse] = useState<any[]>([])
    const [editor, setEditor] = useState<null | E>(null)

    const [fileList, setFileList] = useState<any[]>([])

    const [editorVisible, setEditorVisible] = useState<boolean>(false)
    const [articleType, setArticleType] = useState<any[]>([])

    let { id }: { id: string } = useParams()

    useEffect(() => {
        if (editorVisible && editor === null) {
            renderEditor()
        }
    }, [editorVisible])

    useEffect(() => {
        axiosTable.get('/manage_center/article_type/list', { params: { type_name: '' } }).then((res: any) => {
            setArticleType(res)
        })

        if (id) {
            axiosTable.get("/manage_center/article/detail", { params: { id } }).then((res: any) => {
                res.content_scan_pic_url = [{ id: '', response: { data: [res.content_scan_pic_url] }, url: res.content_scan_pic_url }]
                res.content_detail = Base64.fromBase64(res.content_detail)

                setResponse(res)
                formInstance.setFieldsValue(res)
            })
        }
    }, [])

    const onFinish = (values: any) => {
        let url: string = '';
        values.content_scan_pic_url = values.content_scan_pic_url[0].response.data[0]

        if (id) {
            // 编辑
            let newObj: any = Object.assign(response, values)
            url = '/manage_center/article/update'
            axiosHandleEvent.post(url, { id, ...newObj }).then(res => {
            })

        } else {
            values.is_published = 1;
            // 新增
            url = '/manage_center/articlec/add';
            axiosHandleEvent.post(url, { ...values }).then(res => {
            })
        }
    }

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const save = async () => {
        try {
            const values = await formInstance.validateFields()
            values.content_scan_pic_url = values.content_scan_pic_url[0].response.data[0]
            values.is_published = 0;

            let url: string = '';

            if (id) {
                // 编辑
                let newObj: any = Object.assign(response, values)
                url = '/manage_center/article/update'
                axiosHandleEvent.post(url, { id, ...newObj }).then(res => {
                })

            } else {
                // 新增
                url = '/manage_center/article/add';
                axiosHandleEvent.post(url, { ...values }).then(res => {
                })
            }

        } catch (errorInfo) {
            message.warn('提交校验失败')
        }
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const handleModalOk = () => {
        let html = editor?.txt.html()
        formInstance.setFieldsValue({ content_detail: html })

        setEditorVisible(false)
    }

    const renderEditor = () => {
        const editor: any = new E('.editor')
        editor.config.uploadFileName = "files"
        editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'
        editor.config.uploadImgParams = {
            fileType: 1,
            bucketType: 4
        }

        editor.config.uploadImgHeaders = {
            token: Cookies.get('token')
        }

        editor.config.uploadImgHooks = {
            // 例如，服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert: function (insertImgFn: any, result: any) {
                // result，即服务端返回的接口
                insertImgFn(result.data[0])
            }
        }

        editor.create()
        setEditor(editor)

        editor?.txt.html(formInstance.getFieldValue('content_detail'))
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    const articleHtml = (
        articleType.map((item: object | any) => {
            return <Option value={item.article_type_id} key={item.id}>{item.type_name}</Option>
        })
    )

    return <div className="common-level2-edit">
        <h2>{id ? '编辑' : '新增'}文章</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_editor" onFinish={onFinish}>
                <Form.Item label="文章标题" name='title' rules={[{ required: true, message: '必须输入文章标题' }, () => ({
                    validator(_, value) {
                        if (!/\s/.test(value)) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('不能输入空格'));
                    },
                })]}>
                    <Input placeholder="请填写文章标题" maxLength={30} />
                </Form.Item>

                <Form.Item label="文章分类" name='article_type_id' rules={[{ required: true, message: '必须选择所属分类' }]}>
                    <Select style={{ width: 150 }} placeholder='请选择文章分类'>
                        {articleHtml}
                        <Option value='' key=''><Link to="/article_type">+添加分类</Link></Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="content_scan_pic_url"
                    label="文章封面图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    extra="（只能上传 1 张，大小不超过3M）"
                    rules={[{ required: true, message: '必须上传文章封面图片' }]}
                >

                    <Upload
                        maxCount={1}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                        fileList={fileList}
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item label="文章简介" name="content_detail" rules={[{ required: true, message: '必须编辑门店简介' }]}  >
                    <Button onClick={() => { setEditorVisible(true) }} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                        {id ? '提交' : '立即发布'}
                    </Button>

                    {id ? '' : <Button htmlType="button" onClick={save} style={{ marginLeft: '20px' }}>
                        存为草稿
                    </Button>}
                </Form.Item>
            </Form>
        </div>

        <Modal
            visible={visible}
            title='浏览图片'
            footer={null}
            onCancel={() => { setVisible(false) }}
        >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>

        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); }} width="800px" onOk={handleModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>
    </div >
}
